/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Audit_TrailInputs */

const en_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit trail`)
};

const ar_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل التدقيق`)
};

const bn_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অডিট ট্রেইল`)
};

const de_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit-Trail`)
};

const es_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de auditoría`)
};

const fr_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piste d'audit`)
};

const pt_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trilha de auditoria`)
};

const zh_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审计追踪`)
};

const tr_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denetim takibi`)
};

const ru_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контрольный журнал`)
};

const pl_svchip_audit_trail = /** @type {(inputs: Svchip_Audit_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ścieżka audytu`)
};

/**
* | output |
* | --- |
* | "Audit trail" |
*
* @param {Svchip_Audit_TrailInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_audit_trail = /** @type {((inputs?: Svchip_Audit_TrailInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Audit_TrailInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_audit_trail(inputs)
	if (locale === "bn") return bn_svchip_audit_trail(inputs)
	if (locale === "de") return de_svchip_audit_trail(inputs)
	if (locale === "es") return es_svchip_audit_trail(inputs)
	if (locale === "fr") return fr_svchip_audit_trail(inputs)
	if (locale === "pt") return pt_svchip_audit_trail(inputs)
	if (locale === "zh") return zh_svchip_audit_trail(inputs)
	if (locale === "tr") return tr_svchip_audit_trail(inputs)
	if (locale === "ru") return ru_svchip_audit_trail(inputs)
	if (locale === "pl") return pl_svchip_audit_trail(inputs)
	return en_svchip_audit_trail(inputs)
});